export default {
  400: `
  登録に失敗しました。時間をおいてもう一度お試しいただくか
  下記までお問い合わせください。

  薬キャリ事務局
  pcareer_ad@m3career.com
  `,
  403: `
  ご利用ありがとうございます。
  直近のお問い合わせ件数が上限に達しましたので
  ご利用を制限させて頂いております。

  ご了承頂けますようお願い申し上げます。

  ご不明点等ございましたら下記までお問い合わせください。

  薬キャリ事務局
  pcareer_ad@m3career.com
  `,
  500: `
  登録に失敗しました。時間をおいてもう一度お試しいただくか
  下記までお問い合わせください。

  薬キャリ事務局
  pcareer_ad@m3career.com
  `
}